import icons from "../../../assets/icons";
import { MainRouter, Tabs } from "../../../routes";
import "../../../styles/sidebar.css";

export function Navigation({ currentTab, subtab }) {
    const tabs = Tabs.all;

    const navItemsView = tabs.map((tabItem, i) => {
        const { id, icon: iconName, title, route, subtabs } = tabItem;
        const icon = icons[iconName];

        const onClick = () => {
            MainRouter.goto(route);
        };

        return (<NavItem key={i} selected={id === currentTab} 
            icon={icon} label={title} onClick={onClick} subtab={subtab} subtabs={subtabs || []}></NavItem>)
    });
    
    return (<div className="navigation">
        {navItemsView}
    </div>);
}

function NavItem({ icon, label, selected = false, subtab, onClick, subtabs }) {

    const backgroundStyle = { backgroundImage: `url(${icon})` };
    const rootClasses = selected ? "nav-item selected" : "nav-item";

    return (
        <div className="nav-item-wrapper">
            <div className={rootClasses} onClick={onClick}>
                <div className="icon-wrapper">
                    <div className="icon" style={backgroundStyle}></div>
                </div>
                <label>{label}</label>
            </div>
            { subtabs.length > 0 ? <div className="nav-item-subtabs">
                {subtabs.map(({ id, title, route }, i) => {
                    const onClick = route ? () => MainRouter.goto(route) : () => {};
                    const subtabSelected = id === subtab && selected;
                    return <SubtabItem key={i} selected={subtabSelected} onClick={onClick}>{title}</SubtabItem>
                })}
            </div> : [] }
        </div>
    );
}

function SubtabItem({ children, onClick, selected = false }) {
    return <div className={"subtab" + (selected ? " selected" : "")} onClick={onClick}>{children}</div>
}